module.exports = __webpack_public_path__ + "img/individual_weddingrings.2449b7f.jpg";